<div class="upperSection">
  <div class="menuTitleWithExit">
    <div class="menuTitle" style="padding-top: 11px">
      <div class="title">Viewpoints</div>
    </div>
    <div class="menuTitle exitMenu">
      <mat-icon class="closeIcon" svgIcon="panel.close" (click)="exitVPMenu()"></mat-icon>
    </div>
  </div>
  <div class="treeControllers">
    <span class="expandAll" (click)="expandAll()">Expand All</span>
    <span class="buttonSeperator"></span>
    <span class="collapseAll" (click)="collapseAll()">Collapse All</span>
  </div>
</div>

<div class="middleSection">

  <perfect-scrollbar>
    @if (appConf.showMap) {
      <ins-expansion-box [titleHeight]="'auto'" [forcePadLeft]="true" [expandedListener]="notifyExpandAll" [expanded]="sceneMode === SceneMode.Map"
        [elementOnPanel]="true" [titleStyle]="{margin: '4px 0', 'padding-right': '8px'}" [leftPositionedArrow]="true">
        <div titleContent style="display: flex">
          <mat-icon class="viewpointIcon" svgIcon="mode.map"></mat-icon>
          Maps
        </div>
        <div content class="expansionEntries">
          @if ((mapsVPsToShow).length === 0) {
            <div class="noContentAvailable">No map viewpoint is available</div>
          }
          @for (vp of mapsVPsToShow; track vp) {
            <div class="vpEntryContent" (mouseover)="markHover(true, vp)" (mouseleave)="markHover(false, vp)" [class.active]="selectedVP && vp.id === selectedVP.id">
              <div class="vpStaticContent" [class.defaultVp]="vp.id === defaultViewpointId" (click)="goToSelectedVP(vp)">{{vp.name}}</div>
              @if (hover[vp.id]) {
                <div class="vpHoverContent">
                  @if (isPermEditVP) {
                    <mat-icon class="controlButton editViewpointBtn" svgIcon="sites.edit" (click)="editVP(vp)"></mat-icon>
                  }
                  @if (isPermDeleteVP && vp.id !== defaultViewpointId) {
                    <mat-icon class="controlButton deleteViewpointBtn" svgIcon="app.delete" (click)="deleteVP(vp)"></mat-icon>
                  }
                </div>
              }
            </div>
          }
        </div>
      </ins-expansion-box>
    }
    <ins-expansion-box [titleHeight]="'auto'" [forcePadLeft]="true" [expandedListener]="notifyExpandAll" [expanded]="sceneMode === SceneMode.Facility"
      [elementOnPanel]="true" [titleStyle]="{margin: '4px 0', 'padding-right': '8px'}" [leftPositionedArrow]="true">
      <div titleContent style="display: flex">
        <mat-icon class="viewpointIcon" svgIcon="mode.facility"></mat-icon>
        Facility
      </div>
      <div content class="expansionEntries">
        @if ((facilityVPsToShow).length === 0) {
          <div class="noContentAvailable">No facility viewpoint is available</div>
        }
        @for (vp of facilityVPsToShow; track vp) {
          <div class="vpEntryContent" (mouseover)="markHover(true, vp)" (mouseleave)="markHover(false, vp)" [class.active]="selectedVP && vp.id === selectedVP.id">
            <div class="vpStaticContent" (click)="goToSelectedVP(vp)">{{vp.name}}</div>
            @if (hover[vp.id]) {
              <div class="vpHoverContent">
                @if (isPermEditVP) {
                  <mat-icon class="controlButton editViewpointBtn" svgIcon="sites.edit" (click)="editVP(vp)"></mat-icon>
                }
                @if (isPermDeleteVP) {
                  <mat-icon class="controlButton deleteViewpointBtn" svgIcon="app.delete" (click)="deleteVP(vp)"></mat-icon>
                }
              </div>
            }
          </div>
        }
      </div>
    </ins-expansion-box>
    <ins-expansion-box [titleHeight]="'auto'" [forcePadLeft]="true" [expandedListener]="notifyExpandAll" [expanded]="sceneMode === SceneMode.Panoramic"
      [elementOnPanel]="true" [titleStyle]="{margin: '4px 0', 'padding-right': '8px'}" [leftPositionedArrow]="true">
      <div titleContent style="display: flex">
        <mat-icon class="viewpointIcon" svgIcon="mode.panoramic"></mat-icon>
        Panoramic
      </div>
      <div content class="expansionEntries">
        @if ((panoVPsToShow).length === 0) {
          <div class="noContentAvailable">No panoramic viewpoint is available</div>
        }
        @for (vp of panoVPsToShow; track vp) {
          <div class="vpEntryContent" (mouseover)="markHover(true, vp)" (mouseleave)="markHover(false, vp)" [class.active]="selectedVP && vp.id === selectedVP.id">
            <div class="vpStaticContent" (click)="goToSelectedVP(vp)">{{vp.name}}</div>
            @if (hover[vp.id]) {
              <div class="vpHoverContent">
                @if (isPermEditVP) {
                  <mat-icon class="controlButton editViewpointBtn" svgIcon="sites.edit" (click)="editVP(vp)"></mat-icon>
                }
                @if (isPermDeleteVP) {
                  <mat-icon class="controlButton deleteViewpointBtn" svgIcon="app.delete" (click)="deleteVP(vp)"></mat-icon>
                }
              </div>
            }
          </div>
        }
      </div>
    </ins-expansion-box>
  </perfect-scrollbar>
</div>

<div class="lowerSection itemControllers">
  @if (isPermAddVP) {
    <div id="addViewpointBtn" class="textButtonOnPanel" (click)="addVP()">Add Viewpoint</div>
  }
</div>
